var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icp-footer"},[_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v(" 津ICP备2021001502号-5 ")])])
}]

export { render, staticRenderFns }